import { Card, Table, Tag, Tabs, Input, Space, DatePicker } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { api, Page } from '../api/client';
import dayjs from 'dayjs';

export function AuditLogPage() {
  const [tab, setTab] = useState<'audit' | 'access'>('audit');
  const [q, setQ] = useState('');
  const [page, setPage] = useState(1);

  const { data } = useQuery({
    queryKey: ['audit-logs', { tab, q, page }],
    queryFn: () =>
      api.get<any, Page<any>>(`/admin/${tab === 'audit' ? 'audit-log' : 'access-log'}`, {
        params: { q, page, size: 30 },
      }),
  });

  return (
    <div>
      <div className="tg-page-title">审计日志</div>
      <Card>
        <Tabs
          activeKey={tab}
          onChange={(k) => { setTab(k as any); setPage(1); }}
          items={[
            { key: 'audit', label: '写操作（audit_log）' },
            { key: 'access', label: '敏感读操作（access_log）' },
          ]}
        />
        <Space style={{ marginBottom: 16 }}>
          <Input.Search
            placeholder="操作人 / target / action"
            allowClear
            onSearch={(v) => { setQ(v); setPage(1); }}
            style={{ width: 280 }}
          />
        </Space>
        <Table
          rowKey="id"
          dataSource={data?.items}
          pagination={{
            current: data?.page,
            pageSize: data?.size,
            total: data?.total,
            onChange: setPage,
          }}
          columns={[
            { title: '时间', dataIndex: 'createdAt', width: 160, render: (v) => dayjs(v).format('YYYY-MM-DD HH:mm:ss') },
            { title: '操作人', dataIndex: ['actor', 'name'], width: 100 },
            { title: '动作', dataIndex: 'action', render: (v) => <Tag>{v}</Tag> },
            { title: '对象', dataIndex: 'target', ellipsis: true },
            { title: 'IP', dataIndex: 'ip', width: 130 },
            { title: 'UA', dataIndex: 'userAgent', ellipsis: true },
          ]}
          expandable={{
            expandedRowRender: (r) => (
              <pre style={{ maxHeight: 240, overflow: 'auto', background: '#fafafa', padding: 8 }}>
                {JSON.stringify({ before: r.before, after: r.after, detail: r.detail }, null, 2)}
              </pre>
            ),
          }}
        />
      </Card>
    </div>
  );
}
